import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import type { ReadinessResponse } from '@solar/contracts';

import { healthService } from '../services/health.service';

export const READINESS_QUERY_KEY = ['health', 'readiness'] as const;

/**
 * Polls API readiness.
 *
 * The interval is short because this page exists to tell a developer whether
 * the backend is up right now; product screens use the default cache policy.
 */
export function useReadiness(): UseQueryResult<ReadinessResponse, Error> {
  const isTest = import.meta.env.MODE === 'test';

  return useQuery({
    queryKey: READINESS_QUERY_KEY,
    queryFn: () => healthService.readiness(),
    refetchInterval: isTest ? false : 15_000,
    staleTime: isTest ? 0 : 5_000,
  });
}
